<template>
<div class="col q-mini-drawer-hide">
  <q-list sparator class="tree tree--project tree--full-height">
    <expansion-item
        expand-icon-toggle
        class="tree__item tree_item--active"
        default-opened
    >
      <template v-slot:header>
        <div class="heading-4">
          {{ project.latest_version.title }}
        </div>
      </template>
      <q-list separator class="tree">
        <expansion-item
            expand-icon-toggle
            switch-toggle-side
            default-opened
            class="tree__item text-weight-medium"
            :content-inset-level="0.8"
        >
          <template v-slot:header>
            <div class="row items-center">
              <status-dot :status="$phaseStatusColor(phase.pivot.status)" class="q-mr-md" />
              <common-link
                  :href="$route('project.rule.index', {project_id: project.latest_version.project_id, phase_id: phase.id})">
               {{ phase.title }}
              </common-link>
            </div>
          </template>
          <q-list separator class="tree">
            <q-item>
              <q-item-section>
                {{ ruleVersion.rule.code }}
              </q-item-section>
            </q-item>
          </q-list>
        </expansion-item>
      </q-list>
    </expansion-item>
  </q-list>
</div>
</template>

<script>
import { phaseStatusMixin } from '~HIOR/mixins'

export default {
  mixins: [phaseStatusMixin],
  props: {
    project: {
      type: Object,
    },
    phase: {
      type: Object,
      default: undefined,
    },
    ruleVersion: {
      type: Object,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
